<template>
  <div v-if="isLoading || documents.length" class="pt-2">
    <p class="product-type">Documenten</p>
    <p v-if="isLoading" class="has-text-grey">Laden...</p>
    <div v-else class="buttons mb-0">
      <a
        v-for="doc in documents"
        :key="doc.key"
        :href="doc.url"
        target="_blank"
        rel="noopener"
        class="button is-small is-info is-outlined"
        :title="doc.title"
      >
        <span class="icon is-small"><i class="fas fa-file-pdf"></i></span>
        <span>{{ doc.label }}</span>
      </a>
    </div>
  </div>
</template>

<script setup>
// Documents of the installation task as buttons: the as-built (generated, or the one migrated from
// Sollit), the installation report and service forms of migrated Sollit addresses. The task detail
// already returns them as signed links (asbuilt card, documents card), the same the task details show.
import { computed } from 'vue'
import { useTaskDetail } from './composables/useTaskDetail'

const props = defineProps({
  address: { type: String, required: true },
  project: { type: String, default: null },
})

const LABELS = {
  installation_report: 'Installatierapport',
  sollit_asbuilt: 'As-built (Sollit)',
}

const label = (field, name) => {
  if (LABELS[field]) return LABELS[field]
  const service = field.match(/^service_form(?:_(\d+))?$/)
  if (service) return `Serviceformulier${service[1] ? ` ${service[1]}` : ''}`
  return name || field.replace(/_/g, ' ')
}

const { data: components, isInitialLoading: isLoading } = useTaskDetail(
  computed(() => props.address),
  'installation',
  computed(() => props.project)
)

const documents = computed(() => {
  const result = []
  const asbuilt = components.value?.asbuilt?.asbuilt_pdf_viewer
  if (asbuilt?.url) {
    result.push({ key: 'asbuilt', url: asbuilt.url, label: 'As-built', title: asbuilt.name || 'As-built' })
  }
  Object.entries(components.value?.documents ?? {})
    .filter(([field, doc]) => field !== 'name' && typeof doc?.value === 'string' && doc.value)
    .forEach(([field, doc]) => {
      result.push({ key: field, url: doc.value, label: label(field, doc.name), title: doc.name || field })
    })
  return result
})
</script>

<style scoped>
.product-type {
  font-size: 0.75em;
  font-weight: bold;
  text-transform: uppercase;
  color: #7a7a7a;
  letter-spacing: 0.03em;
}
</style>
